export function track(code: string) {
  try {
    mixpanel.track(code)
    // ga('send', 'event', 'action', code)
  } catch (e) {
  }
}




// WEBPACK FOOTER //
// ./src/service/event.ts